import { api } from './client';
import type { ApiResponse } from '../types';

export interface SiteComment {
  id: string;
  post_id: string;
  parent_id: string | null;
  author_name: string;
  body: string;
  status: 'published' | 'hidden' | 'deleted';
  pinned: boolean;
  created_at: string;
  updated_at: string;
  likes: number;
}
export type CommentModeration = 'hide' | 'restore' | 'pin' | 'unpin' | 'delete';
export const commentsApi = {
  setPostEnabled: (slug: string, postId: string, enabled: boolean) =>
    api.put<ApiResponse<null>>(`/v1/sites/${encodeURIComponent(slug)}/comments-post/${encodeURIComponent(postId)}`, { enabled }),
  list: (slug: string, page = 1) => api.get<ApiResponse<SiteComment[]>>(`/v1/sites/${encodeURIComponent(slug)}/comment-moderation?page=${page}`),
  moderate: (slug: string, comment_id: string, action: CommentModeration) =>
    api.post<ApiResponse<null>>(`/v1/sites/${encodeURIComponent(slug)}/comment-moderation`, { comment_id, action }),
};
